import styled, { css } from 'styled-components';
import { ErrorMessage } from 'formik';
import { DEFAULT_FONT } from 'commons/styles/font';

export const Label = styled.label<{
  disabled?: boolean;
}>`
  font-size: 11px;
  font-style: normal;
  letter-spacing: 0.3px;
  margin-bottom: 14px;
  font-weight: 700;
  line-height: 15px;
  text-transform: uppercase;
  color: ${({ theme: { palette } }) => palette.grey[400]};

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme: { palette } }) => palette.grey[100]};
    `}

  span {
    font-size: 11px;
    font-weight: 400;
    line-height: 15px;
  }
`;

export const Container = styled.div<{
  marginBottom?: string;
  maxWidth?: string;
  width?: string;
  padding?: string;
  margin?: string;
  disabled?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};
  position: relative;
  width: ${({ width }) => width ?? '100%'};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  height: 100%;

  textarea {
    display: block;
    padding: 15px;
    height: 100px;
    border: solid 1px ${({ theme: { palette } }) => palette.grey[100]};
    resize: none;
    font-family: ${DEFAULT_FONT};

    &::placeholder {
      font-family: ${DEFAULT_FONT};
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${({ theme: { palette } }) => palette.grey[400]};
    }

    &:disabled {
      color: ${({ theme: { palette } }) => palette.grey[100]};
      background: #ffffff;
    }

    &.error {
      border: 1px solid red;
    }
  }

  .tooltip-container {
    width: 185px;
  }
`;

export const Errors = styled(ErrorMessage)`
  color: red;
`;

export const Indicator = styled.p<{ disabled?: boolean }>`
  color: ${({ theme: { palette } }) => palette.grey[400]};
  text-align: end;
  margin-top: 5px;

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme: { palette } }) => palette.grey[100]};
    `}
`;
